import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UNINITIALIZED } from 'src/utils/Domain/Constants';
import { BoundPerspectiveAndTenant, TenantConfig } from './codecs/bindings.types';
import { hotSwitchActivePerspective } from 'src/pages/NavigationShell/NavigationShell.slice';
import { defaultWorklistButtons } from './codecs/confdefnView';

export interface AppConfigSlice {
  tenantConfig: TenantConfig;
  configFingerprint?: string;
  confDefns: Record<string, BoundPerspectiveAndTenant>;
}

const defaultConfig = {
  id: UNINITIALIZED,
  defaultTab: UNINITIALIZED,
  flowStatus: {
    values: [],
    defaultSelection: [],
  },
  lookBackPeriods: [],
  perspectives: [],
  placeholder: {
    text: 'PLACEHOLDER',
  },
  context: {
    assortment: { tabs: [], worklistConfigButtons: defaultWorklistButtons },
    hindsighting: { tabs: [], worklistConfigButtons: defaultWorklistButtons },
    allocation: { tabs: [], worklistConfigButtons: defaultWorklistButtons },
  },
  tabs: [],
  printSizes: [],
  canAddNewStyles: true,
  showBookmarks: false,
  disableScope: true,
  disableFilters: true,
  fabTypes: {},
} as TenantConfig;

export const initialState: AppConfigSlice = {
  tenantConfig: defaultConfig,
  confDefns: {},
};

const appConfigSlice = createSlice({
  name: 'AppConfig',
  initialState,
  reducers: {
    updateAppConfig(state, action: PayloadAction<TenantConfig>) {
      state.tenantConfig = action.payload;
    },
    updateConfigFingerPrint(state, action: PayloadAction<string>) {
      state.tenantConfig = state.tenantConfig;
      state.configFingerprint = action.payload;
    },
    updateConfDefns(state, action: PayloadAction<Record<string, any>>) {
      state.confDefns = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(hotSwitchActivePerspective, (state, action) => {
      state.tenantConfig = action.payload.selected.tenant;
    })
  }
});

export const { updateAppConfig, updateConfigFingerPrint, updateConfDefns } = appConfigSlice.actions;

export default appConfigSlice.reducer;
